import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";
import { hasMonthlyBrandLimitExceeded } from "../../../utils/redemptionAllowance";

const initialState = {
  loading: false,
  issueRewardData: {},
  error: "",
  success: false,
  status: "",
};

const issueRewardCall = createAsyncThunk(
  "post/rewards",
  async ({ data, id, rewardName }, { rejectWithValue }) => {
    const token = localStorage.getItem("token");
    const mobile = localStorage.getItem("mobile");
    try {
      const result = await axios.post(
        `https://apac.api.capillarytech.com/mobile/v2/api/marvel/rewards/issue?id=${id}&till_id=${process.env.REACT_APP_TILL_ID}`,
        { ...data, rewardName },
        {
          commonHeaderNotRequired: true,
          headers: {
            cap_brand: process.env.REACT_APP_BRAND,
            cap_authorization: token,
            cap_device_id: process.env.REACT_APP_DEVICE_ID,
            cap_mobile: mobile,
          },
        },
      );

      if (hasMonthlyBrandLimitExceeded(result?.data)) {
        return rejectWithValue(result.data);
      }

      return result?.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err?.data || err);
    }
  },
);

const issueRewardSlice = createSlice({
  name: "issue-reward",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(issueRewardCall.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(issueRewardCall.fulfilled, (state, action) => {
      // console.log(action.payload, "Payload Issue reward");
      state.loading = false;
      state.issueRewardData = action.payload;
      state.success = action.payload;
      state.error = "";
    });
    builder.addCase(issueRewardCall.rejected, (state, action) => {
      state.loading = false;
      state.issueRewardData = action.payload || {};
      state.error = action.payload || action.error.message;
      state.success = false;
    });
  },
});

export default issueRewardSlice.reducer;
export const { reset } = issueRewardSlice.actions;
export { issueRewardCall };
